// TODO add IZStackProps for consistency.
// The current version doesn't expose these props, but they are exposed in the master branch
export { ZStack } from 'native-base';
